//--------------------------------------------------------------------------------------------------

  var helpers = {}

//--------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------

  helpers.someFunction = function() {
    
  }

//--------------------------------------------------------------------------------------------------

  helpers.rearrange_blocks = function( new_layout_type, blocks ){

    var new_blocks_pieces = []

    for( var i = 0; i < blocks.length; i++ ) {
      var block = blocks[i]
      for( var ii = 0; ii < block.pieces.length; ii++ ) {
        var piece = block.pieces[ii]
        new_blocks_pieces.push( piece )
      }      
    }    

    var pieces_per_block = new_layout_type.split('-').length

    var chunks = helpers.array_chunk(new_blocks_pieces, pieces_per_block)
    
    var new_blocks = [] 

    for( var i = 0; i < chunks.length; i++ ) {
      var chunk = chunks[i]
      new_blocks.push({
        layout: new_layout_type,
        pieces: chunk,
      })
    }    

    return new_blocks

  }

//--------------------------------------------------------------------------------------------------

  helpers.blocks_filter_capbelowblock = function( blocks ){
    var output = []
    for( var i = 0; i < blocks.length; i++ ) {
        var block = blocks[i]
        if( block.layout == 'H' ) return output
        output.push( block )
    }
    return output
  }

//--------------------------------------------------------------------------------------------------

  helpers.blocks_filter_nohideblocks = function( blocks ){
    return blocks.filter(function(block){ return ( !block.hide || block.hide != true ) })
  }

//--------------------------------------------------------------------------------------------------

  helpers.blocks_contains_type = ( blocks, type ) => {
    for( var i = 0; i < blocks.length; i++ ) if( blocks[i].layout == type ) return true
    return false
  }

//--------------------------------------------------------------------------------------------------
  
  helpers.getfullname = function(item) {
    if( item.first_name && !item.last_name ) return item.first_name
    if( !item.first_name && item.last_name ) return item.last_name
    if( item.first_name && item.last_name ) return item.first_name +' '+ item.last_name
  }

//--------------------------------------------------------------------------------------------------

  helpers.generate_uid_key = function (length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }
  
//--------------------------------------------------------------------------------------------------

  helpers.array_chunk = function(input, size, preserveKeys) { // eslint-disable-line camelcase
    //  discuss at: http://locutus.io/php/array_chunk/
    // original by: Carlos R. L. Rodrigues (http://www.jsfromhell.com)
    // improved by: Brett Zamir (http://brett-zamir.me)
    //      note 1: Important note: Per the ECMAScript specification,
    //      note 1: objects may not always iterate in a predictable order
    //   example 1: array_chunk(['Kevin', 'van', 'Zonneveld'], 2)
    //   returns 1: [['Kevin', 'van'], ['Zonneveld']]
    //   example 2: array_chunk(['Kevin', 'van', 'Zonneveld'], 2, true)
    //   returns 2: [{0:'Kevin', 1:'van'}, {2: 'Zonneveld'}]
    //   example 3: array_chunk({1:'Kevin', 2:'van', 3:'Zonneveld'}, 2)
    //   returns 3: [['Kevin', 'van'], ['Zonneveld']]
    //   example 4: array_chunk({1:'Kevin', 2:'van', 3:'Zonneveld'}, 2, true)
    //   returns 4: [{1: 'Kevin', 2: 'van'}, {3: 'Zonneveld'}]
  
    var x
    var p = ''
    var i = 0
    var c = -1
    var l = input.length || 0
    var n = []
  
    if (size < 1) {
      return null
    }
  
    if (Object.prototype.toString.call(input) === '[object Array]') {
      if (preserveKeys) {
        while (i < l) {
          (x = i % size)
            ? n[c][i] = input[i]
            : n[++c] = {}; n[c][i] = input[i]
          i++
        }
      } else {
        while (i < l) {
          (x = i % size)
            ? n[c][x] = input[i]
            : n[++c] = [input[i]]
          i++
        }
      }
    } else {
      if (preserveKeys) {
        for (p in input) {
          if (input.hasOwnProperty(p)) {
            (x = i % size)
              ? n[c][p] = input[p]
              : n[++c] = {}; n[c][p] = input[p]
            i++
          }
        }
      } else {
        for (p in input) {
          if (input.hasOwnProperty(p)) {
            (x = i % size)
              ? n[c][x] = input[p]
              : n[++c] = [input[p]]
            i++
          }
        }
      }
    }
  
    return n
  }

  helpers.capitalize = (s) => {
    if (typeof s !== 'string') return ''
    if( !s.length ) return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  
  helpers.scrollTo2 = function(to, duration) {
      const
      element = document.scrollingElement || document.documentElement,
      start = element.scrollTop,
      change = to - start,
      startDate = +new Date(),
      // t = current time
      // b = start value
      // c = change in value
      // d = duration
      easeInOutQuad = function(t, b, c, d) {
          t /= d/2;
          if (t < 1) return c/2*t*t + b;
          t--;
          return -c/2 * (t*(t-2) - 1) + b;
      },
      animateScroll = function() {
          const currentDate = +new Date();
          const currentTime = currentDate - startDate;
          element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
          if(currentTime < duration) {
              requestAnimationFrame(animateScroll);
          }
          else {
              element.scrollTop = to;
          }
      };
      animateScroll();
  };
  
  
 helpers.scrollTo = (element, to, duration) => {
     var start = element.scrollTop,
         change = to - start,
         currentTime = 0,
         increment = 20;
         
     var animateScroll = function(){               
         currentTime += increment;
         var val = helpers.ease_fn_easeInOutQuad(currentTime, start, change, duration);
         element.scrollTop = val;
         if(currentTime < duration) {
             setTimeout(animateScroll, increment);
         }
     };
     animateScroll();
 }
 
 helpers.ease_fn_easeInOutQuad = function (t, b, c, d) {
   t /= d/2;
   if (t < 1) return c/2*t*t + b;
   t--;
   return -c/2 * (t*(t-2) - 1) + b;
 }



  helpers.capitalizeAll = (s) => {
    return s
      .toLowerCase()
      .split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ')
  }

  helpers.slugify = ( text ) => {
    return text.toString().toLowerCase()
    .replace(/ø/g,'oe')
    .replace(/æ/g,'ae')
    .replace(/å/g,'aa')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
  }
  
  helpers.unslugify = ( slug ) => {
    if( !slug ) return
    slug = slug.split('-').join(' ')
    slug = helpers.capitalizeAll(slug)
    return slug
  }

  helpers.strip_blocks_pieces_metadata = function(blocks) {
    for( var i = 0; i < blocks.length; i++ ) {
      var block = blocks[i]
      if( block.pieces ) {
        for( var ii = 0; ii < block.pieces.length; ii++ ) {
          var piece = block.pieces[ii]
          if( !piece ) continue
          if( piece.metadata ) delete piece.metadata
        }
      }
      
    }
    return blocks
  }

//--------------------------------------------------------------------------------------------------

  helpers.passphrase_mangle = (str) => {
    if( str === undefined || str === null ) return str
    if( typeof str === 'number' ) str = str+''
    var output = btoa(str.split('').reverse().join(''))
    return output
  }
  helpers.passphrase_unmangle = (str) => { return atob(str).split('').reverse().join('') }

//--------------------------------------------------------------------------------------------------

  helpers.passgate = () => {

    var i4n2jkhb = localStorage.getItem('i4n2jkhb')
    if( i4n2jkhb ) return true

    var k = prompt('Please enter the passcode. If you do not have one, please write to alle@scoopmodels.com and ask for one.')
    if( parseInt(k) != 9319 ) {
      alert('Please write to alle@scoopmodels.com and ask for a passcode.')
      return false
    }

    localStorage.setItem('i4n2jkhb','ljn4h2f')
    return true

  }

  helpers.validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

//--------------------------------------------------------------------------------------------------

  helpers.casting_items_groupify = (items) => {

      if(!items) return

      // store native item indexes
			for( let i = 0; i < items.length; i++ ) items[i].native_index = i
			
			// create groups, one per model/artist/influencer
			var groups_obj = {}
			for( let item of items ) {								
				if( item.model ) groups_obj['model_'+item.model_id] = { title: 'Model: ' + item.model.full_name, model: item.model, model_id: item.model.id, items:[], }
				if( item.artist ) groups_obj['artist_'+item.artist_id] = { title: 'artist: ' + item.artist.full_name, artist: item.artist, artist_id: item.artist.id, items:[], }
				if( item.influencer ) groups_obj['influencer_'+item.influencer_id] = { title: 'influencer: ' + item.influencer.full_name, influencer: item.influencer, influencer_id: item.influencer.id, items:[], }				
			}
			var groups = []; for( let key in groups_obj ) groups.push( groups_obj[key] )
			
			// add items to groups
			for( let group of groups ) { for( let item of items ) {
				if( item.model_id && item.model_id == group.model_id ) group.items.push(item)
				if( item.artist_id && item.artist_id == group.artist_id ) group.items.push(item)
				if( item.influencer_id && item.influencer_id == group.influencer_id ) group.items.push(item)
			}}

			// filter empty groups
			groups = groups.filter((group) => { return group.items.length })

			// sort group items > oldest first
			//for( let group of groups ) group.items = group.items.reverse()

			return groups
  }

//--------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------

  export default helpers



// WEBPACK FOOTER //
// ./src/helpers.js